import React, { Component } from 'react';
import ReactModal from 'react-modal';

import Aux from 'hoc/ReactAux/ReactAux';
import Logo from 'images/cart-mark.png';
import {
  GUEST_NAME_ERROR,
  GUEST_NAME_MAX,
  canAddGuest,
  defaultRecipient,
  guestDisplayName,
  isValidGuestName,
  recipientNote,
} from '../../../../config/guestOrdering';
import '../Cart.css';

const ME = 'me';
const NEW_GUEST = 'new';

const customStyles = {
  // Same as the other .lb-geral modals: the .lb-geral layer is position: fixed and
  // centres itself. A transform or overflow here traps it in a 0x0 box, so the
  // sheet was invisible behind the dimmed overlay on phones.
  content: {
    background: 'none',
    border: 'none',
    padding: 0,
  },
  overlay: {
    zIndex: '9999999',
    width: '100%',
    height: '100%',
    left: '0',
    top: '0',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
  },
};

// "Who's this for?": Me, each guest already in the basket, or + New guest.
// Mounted fresh for every Add to basket, so it starts on whoever was picked last.
class GuestRecipientSheet extends Component {
  constructor(props) {
    super(props);
    const lastId = defaultRecipient(props.lastRecipientId, props.guests);
    this.state = {
      choice: lastId || ME,
      firstName: '',
      lastName: '',
      showError: false,
    };
  }

  select = choice => {
    this.setState({ choice, showError: false });
  };

  handleFirstName = event => {
    this.setState({ firstName: event.target.value, showError: false });
  };

  handleLastName = event => {
    this.setState({ lastName: event.target.value, showError: false });
  };

  handleSubmit = event => {
    if (event) event.preventDefault();
    const { choice, firstName, lastName } = this.state;
    if (choice === ME) {
      this.props.onAdd({});
    } else if (choice === NEW_GUEST) {
      if (!isValidGuestName(firstName) || !isValidGuestName(lastName)) {
        this.setState({ showError: true });
        return;
      }
      this.props.onAdd({ newGuest: { firstName, lastName } });
    } else {
      this.props.onAdd({ guestId: choice });
    }
  };

  renderRow(value, label, tag) {
    const id = `guest-recipient-${value}`;
    return (
      <div className="guest-recipient-row" key={value}>
        <input
          type="radio"
          name="guestRecipient"
          id={id}
          checked={this.state.choice === value}
          onChange={() => this.select(value)}
        />
        <label htmlFor={id} className={value === NEW_GUEST ? 'guest-recipient-new' : ''}>
          {label}
          {tag ? <span className="guest-recipient-tag">{tag}</span> : null}
        </label>
      </div>
    );
  }

  render() {
    const { policy, guests, subtitle, onCancel } = this.props;
    const addingAllowed = canAddGuest(policy, guests.length);
    const isNew = this.state.choice === NEW_GUEST;

    return (
      <ReactModal
        isOpen={true}
        style={customStyles}
        onRequestClose={onCancel}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        aria={{ labelledby: 'guest-recipient-title' }}
        contentLabel="Who's this for?"
      >
        <div className="lb-geral lb-guest-recipient_ mfp-bg-login white-popup-block singup zoom-anim-dialog">
          <div className="lb-padrao-singup6 mfp-content-login modal-content">
            <button
              onClick={onCancel}
              type="button"
              className="bt-close mfp-close lb-fechar fa fa-times"
              aria-label="Close"
            />
            <div className="check-mark">
              <img alt="" src={Logo} />
            </div>
            <form className="lb-content" onSubmit={this.handleSubmit} noValidate>
              <h2 id="guest-recipient-title" className="guest-recipient-title">
                Who's this for?
              </h2>
              {subtitle ? <p className="guest-recipient-subtitle">{subtitle}</p> : null}
              <div
                className="guest-recipient-rows"
                role="radiogroup"
                aria-labelledby="guest-recipient-title"
              >
                {this.renderRow(ME, 'Me')}
                {guests.map(guest => this.renderRow(guest.id, guestDisplayName(guest), 'Guest'))}
                {addingAllowed ? this.renderRow(NEW_GUEST, '+ New guest') : null}
              </div>
              {addingAllowed && isNew ? (
                <Aux>
                  <label htmlFor="guestFirstName" className="guest-recipient-field-label">
                    Guest's first name
                  </label>
                  <input
                    id="guestFirstName"
                    className="guest-recipient-field"
                    type="text"
                    maxLength={GUEST_NAME_MAX}
                    autoComplete="off"
                    autoFocus
                    aria-invalid={this.state.showError}
                    aria-describedby="guestRecipientError"
                    value={this.state.firstName}
                    onChange={this.handleFirstName}
                  />
                  <label htmlFor="guestLastName" className="guest-recipient-field-label">
                    Guest's last name
                  </label>
                  <input
                    id="guestLastName"
                    className="guest-recipient-field"
                    type="text"
                    maxLength={GUEST_NAME_MAX}
                    autoComplete="off"
                    aria-invalid={this.state.showError}
                    aria-describedby="guestRecipientError"
                    value={this.state.lastName}
                    onChange={this.handleLastName}
                  />
                </Aux>
              ) : null}
              <p className="guest-recipient-note">{recipientNote(policy, guests.length)}</p>
              <p id="guestRecipientError" className="guest-recipient-error" role="alert">
                {this.state.showError ? GUEST_NAME_ERROR : ''}
              </p>
              <button type="submit" className="orange-bold guest-recipient-add">
                Add to basket
              </button>
            </form>
          </div>
        </div>
      </ReactModal>
    );
  }
}

export default GuestRecipientSheet;



// WEBPACK FOOTER //
// ./src/containers/Menu/Cart/GuestRecipient/GuestRecipientSheet.js